export enum NotificationTypeEnum {
  info = 'info',
  warning = 'warning',
  alert = 'alert',
  reminder = 'reminder',
  promotion = 'promotion',
  system = 'system',
  message = 'message',
  task = 'task',
  update = 'update',
}
